import { CopilotOutput } from 'libs/end-to-end/src/copilot';
import { useMemo } from 'react';
import { createPrefilledSubjectIds } from 'libs/end-to-end/src/copilot-utils';

export const useBasicCopilotSubjectIdsToPrefill = ({
  copilotData,
}: {
  copilotData: CopilotOutput | null;
}) => {
  return useMemo(() => {
    if (!copilotData) {
      return [];
    }

    return createPrefilledSubjectIds(copilotData);
  }, [copilotData]);
};
